import {
    ticketPhases,
    otherCategories,
} from "components/dashboard/AgentInbox/enum";
import {
    INBOX_READ_PERMISSION,
    TICKET_AGENT_ASSISTANT_PERMISSION,
} from "components/dashboard/AgentInbox/permissions";

const { ISSUE_DISCOVERY, PROBLEM_CONFIRMATION, SOLUTION_DELIVERY } =
    ticketPhases;

const { EXTERNAL_EMAILS, MENTIONS, AGENT_ASSISTANCE } = otherCategories;

export const issueDiscovery = [
    {
        value: AGENT_ASSISTANCE,
        label: "Agent's assistant",
        baseResources: TICKET_AGENT_ASSISTANT_PERMISSION,
    },
    {
        value: ISSUE_DISCOVERY,
        label: "Suggestions",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: SOLUTION_DELIVERY,
        label: "Branches",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: EXTERNAL_EMAILS,
        label: "Emails",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: MENTIONS,
        label: "Mentions",
        baseResources: INBOX_READ_PERMISSION,
    },
];

export const problemConfirmation = [
    {
        value: AGENT_ASSISTANCE,
        label: "Agent's assistant",
        baseResources: TICKET_AGENT_ASSISTANT_PERMISSION,
    },
    {
        value: ISSUE_DISCOVERY,
        label: "Suggestions",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: PROBLEM_CONFIRMATION,
        label: "Ticket info",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: SOLUTION_DELIVERY,
        label: "Branches",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: EXTERNAL_EMAILS,
        label: "Emails",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: MENTIONS,
        label: "Mentions",
        baseResources: INBOX_READ_PERMISSION,
    },
];

export const solutionDelivery = [
    {
        value: AGENT_ASSISTANCE,
        label: "Agent's assistant",
        baseResources: TICKET_AGENT_ASSISTANT_PERMISSION,
    },
    {
        value: PROBLEM_CONFIRMATION,
        label: "Ticket info",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: SOLUTION_DELIVERY,
        label: "Branches",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: EXTERNAL_EMAILS,
        label: "Emails",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: MENTIONS,
        label: "Mentions",
        baseResources: INBOX_READ_PERMISSION,
    },
];

export const followupMentions = [
    {
        value: AGENT_ASSISTANCE,
        label: "Agent's assistant",
        baseResources: TICKET_AGENT_ASSISTANT_PERMISSION,
    },
    {
        value: PROBLEM_CONFIRMATION,
        label: "Ticket info",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: SOLUTION_DELIVERY,
        label: "Branches",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: EXTERNAL_EMAILS,
        label: "Emails",
        baseResources: INBOX_READ_PERMISSION,
    },
    {
        value: MENTIONS,
        label: "Mentions",
        baseResources: INBOX_READ_PERMISSION,
    },
];
